@if (isLoading()) {
    <app-loading />
} @else {
    <section class="flex flex-col h-full gap-7">
        <div class="flex">
            <app-management-main-panel-title
                [icon]="['fas', 'lock']"
                [title]="'passwordRules.title' | transloco" />
        </div>
        <h3 class="!font-semibold !text-lg !ml-4">{{ 'passwordRules.subtitle' | transloco }}</h3>
        <form
            class="flex flex-col gap-10 ml-4"
            (ngSubmit)="submitForm()">
            <div class="mx-8 flex flex-col gap-10">
                <ng-container
                    *ngTemplateOutlet="
                        inputSection;
                        context: {
                            control: form.controls.minLength,
                            description: 'passwordRules.minLengthDescription' | transloco,
                            label: 'passwordRules.minLengthLabel' | transloco,
                        }
                    " />

                <ng-container
                    *ngTemplateOutlet="
                        inputSection;
                        context: {
                            control: form.controls.minUppercaseCharacters,
                            description: 'passwordRules.minUppercaseCharactersDescription' | transloco,
                            label: 'passwordRules.minUppercaseCharactersLabel' | transloco,
                        }
                    " />

                <ng-container
                    *ngTemplateOutlet="
                        inputSection;
                        context: {
                            control: form.controls.minNumbers,
                            description: 'passwordRules.minNumbersDescription' | transloco,
                            label: 'passwordRules.minNumbersLabel' | transloco,
                        }
                    " />

                <ng-container
                    *ngTemplateOutlet="
                        inputSection;
                        context: {
                            control: form.controls.minSpecialCharacters,
                            description: 'passwordRules.minSpecialCharactersDescription' | transloco,
                            label: 'passwordRules.minSpecialCharactersLabel' | transloco,
                        }
                    " />
            </div>

            <div class="flex flex-row gap-2">
                <app-checkbox
                    [checkboxState]="form.controls.sendMail.value ? CheckboxState.CHECKED : CheckboxState.UNCHECKED"
                    (click)="toggleSendMailControlValue()" />
                {{ 'passwordRules.sendMailLabel' | transloco }}
            </div>

            <app-button
                [disabled]="!form.dirty"
                [htmlType]="'submit'"
                [label]="'validate' | transloco"
                [type]="ButtonType.PRIMARY" />
        </form>
    </section>
}

<ng-template
    #inputSection
    let-control="control"
    let-description="description"
    let-label="label">
    <div class="flex flex-col gap-2">
        <div class="flex flex-row gap-2 items-center">
            <app-toggle
                [checked]="!!control.value"
                (toggled)="setControlValue(control, $event)" />
            <span class="font-medium text-base">{{ label }}</span>
        </div>
        <div class="flex flex-row gap-2 items-center pl-5">
            <app-input-number
                [additionalClasses]="'w-12'"
                [disabled]="!control.value"
                [inputFormControl]="control"
                [min]="1"
                [placeholder]="'1'" />
            {{ description }}
        </div>
    </div>
</ng-template>
